var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyDeactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_802_2109",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 18,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8888 5.27869C15.8888 8.04005 13.6503 10.2786 10.889 10.2786C8.1277 10.2786 5.88921 8.04005 5.88921 5.27869C5.88921 2.51733 8.1277 0.278809 10.889 0.278809C13.6503 0.278809 15.8888 2.51733 15.8888 5.27869Z",
    fill: "#006FFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55597 16.9455C2.55597 14.1842 4.79446 11.9457 7.55577 11.9457H14.2222C16.9835 11.9457 19.222 14.1842 19.222 16.9455V17.7789C19.222 19.1595 18.1027 20.2788 16.7221 20.2788H5.05587C3.67521 20.2788 2.55597 19.1595 2.55597 17.7789V16.9455Z",
    fill: "#006FFD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_802_2109)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.889465,
    y: 0.277832,
    width: 19.9992,
    height: 19.9995,
    fill: "#8D8D8D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyDeactive);
export default __webpack_public_path__ + "static/media/myDeactive.54da32ebcdda1f477ee0bbaed8826575.svg";
export { ForwardRef as ReactComponent };